var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{attrs:{"id":_vm._uid,"width":"400","height":"300"}})])}
var staticRenderFns = []

export { render, staticRenderFns }